import React, {ReactElement, ReactNode} from 'react';

import './Icon.scss';

export enum IconSize {
  EXTRA_LARGE = 'xl',
  EXTRA_SMALL = 'xs',
  LARGE = 'l',
  MEDIUM = 'm',
  SMALL = 's',
}

export enum IconRotation {
  NONE = '0',
  CW_90 = '90',
  CW_180 = '180',
  CW_270 = '270',
  CCW_90 = '-90',
  CCW_180 = '-180',
  CCW_270 = '-270',
}

export interface IconProps {
  size?: IconSize;
  rotation?: IconRotation;
  className?: string;
  testId?: string;
}

interface IconWrapperProps extends IconProps {
  children: ReactNode;
}

function IconWrapper({size = IconSize.MEDIUM, rotation, testId, className, children}: IconWrapperProps): ReactElement {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={`icon icon--${size} ${className || ''}`.trim()}
      style={
        rotation && {
          transform: `rotate(${rotation}deg)`,
        }
      }
      data-testid={testId}
    >
      {children}
    </svg>
  );
}

export default IconWrapper;
